import React, { useState, useEffect } from 'react'

import Grid from '@mui/material/Grid';

import PharmaorderFilterCriteria from './PharmaorderFilterCriteria'
import PharmaorderListImpl from './PharmaorderListImpl'
import MyPageContainer from '../../core/template/MyPageContainer';
import {getListAPI} from './PharmaorderAPI';
import {transformToCardFormat} from '../../core/js/FormUtils'
import {getPathVariable} from '../../core/js/UrlUtils';

import { useSearchParams } from "react-router-dom";
import { useSelector, useDispatch } from 'react-redux';
import {setPharmaorderDashboardPharmaorderList } from '../../store/slice/PharmaSlice';

export default function PharmaorderListView({setShowEdit,setPharmaorderId}){
    const {filterCriteria} = useSelector((state)=>state.pharmaslice.pharmaorderDashboard);   

    const [filteredPharmaorderList, setFilteredPharmaorderList] = React.useState([]);
    const [cardList, setCardList] = useState([]);
    const [searchParams, setSearchParams] = useSearchParams();
    const { showfilter } = useSelector((state) => state.confslice);
    const { pharmaorderDashboard } = useSelector((state) => state.pharmaslice);
    
    function dataFetchCallBack(){
    }

    useEffect(()=>{
      if (pharmaorderDashboard.pharmaorderList.length>-1){
        setFilteredPharmaorderList(pharmaorderDashboard.pharmaorderList);
        transformToCardFormat(pharmaorderDashboard.pharmaorderList, setCardList);
      }
    },[pharmaorderDashboard.pharmaorderList])

    useEffect(()=>{
          transformToCardFormat(filteredPharmaorderList, setCardList);
      },[filteredPharmaorderList])

    useEffect(()=>{
        if (filterCriteria.executivename==='' && filterCriteria.ordervalue==='' && filterCriteria.dispatchdate==='' && filterCriteria.partyname==='' && filterCriteria.partyid==='' && filterCriteria.orderid==='' && filterCriteria.orderstatus==='' && filterCriteria.subtotal==='' && filterCriteria.gstamount==='' && filterCriteria.advance==='' && filterCriteria.submitdate==='' && filterCriteria.deliverydate==='' && filterCriteria.executiveid==='' ){
            setFilteredPharmaorderList(pharmaorderDashboard.pharmaorderList);
            transformToCardFormat(pharmaorderDashboard.pharmaorderList, setCardList);

        } else {
            setFilteredPharmaorderList(
                pharmaorderDashboard.pharmaorderList
                    .filter(pharmaorder=> pharmaorder.executivename.toString().toUpperCase().includes(filterCriteria.executivename.toString().toUpperCase()))
.filter(pharmaorder=> pharmaorder.partyname.toString().toUpperCase().includes(filterCriteria.partyname.toString().toUpperCase()))
.filter(pharmaorder=> pharmaorder.orderid.toString().toUpperCase().includes(filterCriteria.orderid.toString().toUpperCase()))
.filter(pharmaorder=> pharmaorder.orderstatus.toString().toUpperCase().includes(filterCriteria.orderstatus.toString().toUpperCase()))

                
            )
            

            //transformToCardFormat(pharmaorderDashboard.filteredPharmaorderList, setCardList);
        }
      },[filterCriteria])
  
     return(
        <Grid container direction="column" >
            <Grid item lg={12}>
                <PharmaorderListImpl
                    setShowEdit={setShowEdit}
                    setPharmaorderId = {setPharmaorderId}
                    tableList={filteredPharmaorderList}
                    cardList={cardList}
                    />
          </Grid>
      </Grid>
    )
}